import React, { Component} from 'react';
import { InputSlider } from '../inputSlider';
import { Tooltip} from '@hiver/hiver-react-component-library';
import { Box, IconButton, Typography, theme, Tooltip as HuiTooltip } from '@hiver/hiver-ui-kit';
import injectSheet from 'react-jss';
import Alert from '../Alert'
import SettingsActive from '../../images/settings.svg';
import UpgradeRocketIcon from 'h-commons/images/upgrade-rocket-small.svg';
import UpgradeHoverBar from '../UpgradeHoverBar'
import SettingsDeactive from '../../images/settingsTransparent.svg';
import SessionedLink from '../SessionedLink';
import TimerIcon from '../TimerIcon/TimerIcon';

import SVGInline from 'react-svg-inline';

const UPGRADE_TEXT = "This is not available on your current plan. "
const UPGRADE_LINK = "Upgrade now to access this feature."

const sliderTooltipStyles = {
    '&.MuiTooltip-popper':{ 
        '& .MuiTooltip-tooltip':{
            maxWidth:'104px',
            padding: theme.spacing(0.5, 1),
            borderRadius: theme.spacing(0.5)
        },
        '& .MuiTypography-root':{
            color: 'gray.white'
        }
    }
}

 class ListItemView extends Component {
    state = {
        state: false,
        hoverBarState: false
    }
    /**
     * Syncs state from props
     * @param props new props to sync state with
     * @returns undefined
     */
    syncState = props => {
        const { data, isLoading } = props;
        if ('state' in data) {
            this.setState({
                state: data.state
            });
        }
    }
    componentWillMount(){
        this.syncState(this.props);
    }
    componentWillReceiveProps(nextProps){
        const { isLoading } = nextProps;
        //only sync state when it's not fetching data
        if (nextProps.hasOwnProperty('isLoading') && isLoading !== true)
            this.syncState(nextProps);
    }

    toggleSubItem = (status) => {
        const {onSettingsToggle,id} = this.props
        const newStatus = typeof status === 'boolean' ? status :!this.props.subItemActive;
            if(typeof onSettingsToggle === 'function'){
                onSettingsToggle({status:newStatus, id})
            }
    }

    renderErrorAlert = () => {
        const { hasError} = this.props;
        return hasError ? <Alert type="error" text="Temporary unavailable. Please reload the page to try again"/>: null;
    }

    renderChildren = () => {
        const { children, hasError} = this.props;
        return (
            children && !hasError ? children({active:this.props.subItemActive}) : null
        );
    }

    toggleHoverBar = (upgradePlan, status) => {
        if (!upgradePlan) {
            return;
        }
        this.setState({ hoverBarState: status })
    }

    renderTag = () => {
        const {data,classes} = this.props;
        if(!data.tag){
            return null;
        }
        
        return(
        <React.Fragment>    
            <span data-for="auto_assign_tag" data-tip="" className={classes.tag}>
                {data.tag.title}
            </span>
            <Tooltip
                id="auto_assign_tag"
                place="bottom"
                className={classes.tagTooltip}
                delayShow={200}
                effect="solid"
                arrow={true}
                isHUI
            >
                    {data.tag.tooltip}
            </Tooltip>
        </React.Fragment>
        )

    }
   
    renderChildComponent = () => {
        const { data } = this.props;

        if (data.childComponent) {
            return (
                <Box sx={{marginTop: theme.spacing(1.5)}}>
                    {data.childComponent}
                </Box>
            );
        }
    }

    showSliderTooltip = () => {
        const { data } = this.props;

        if (data.showTooltip) {
            return (
                <Typography variant='caption'>
                    <SessionedLink to="/app/settings/account/upgrade">
                        <Typography 
                            component='span'
                            variant='caption' 
                            fontWeight='fontWeightSemiBold' 
                            sx={{ textDecoration: 'underline' }}
                        >
                            Upgrade
                        </Typography>
                    </SessionedLink>
                    {' to remove branding'}
                </Typography>
            );
        }
    }

    render () {
        const { data, id, actionText, icon, onAction, variant, listItemStyle, children, classes, hasError, upgradePlan,subItemActive, showToggle=true, sliderProps={}, isExploringHigherPlan = false } = this.props;
        const lastUpdated =
          data.updated_by && data.updated_at
            ? `Last changed by ${data.updated_by.firstname} on ${data.updated_at}.`
            : null;
        const listItemClass = typeof listItemStyle === 'string' ? listItemStyle : '';      
        if(!variant || variant === 'simple')
            return(
                <div className={`${listItemClass} h-action-li`}>    
                    <span className="h-action-li-text">
                        { icon }
                        <Typography variant="body2" style={{ color: theme.palette.gray.gray1 }} component="span">
                            {data.text}
                        </Typography>
                    </span>
                    <span className="h-s3 h-action-li-action h-pointer" onClick={() => onAction({ id, text: data.text })}>
                        {/* { icon } */}
                        <Typography 
                            variant="h3" 
                            color={theme.palette.purple.primary} 
                            style={{ letterSpacing: '0.2px !important', lineHeight: '28px !important' }}>
                            {actionText}
                        </Typography>
                    </span>
                </div>
            );
        else if(variant === 'enableList') {
            const handleToggle = () => {
                const state = !this.state.state; //toggle the state
                this.setState({ state });
                onAction({id, data, toggleSubItem: this.toggleSubItem});
            }
            return (
                <React.Fragment>
                <div 
                    className={`h-action-enable-list ${listItemClass} h-flexbox--sb-vc ${upgradePlan ? 'disabled' : ''}`}
                    onMouseOver={()=>{this.toggleHoverBar(upgradePlan, true)}}
                    onMouseLeave={()=>{this.toggleHoverBar(upgradePlan, false)}}    
                >
                    {upgradePlan && this.state.hoverBarState ? <UpgradeHoverBar text={UPGRADE_TEXT} linkText={UPGRADE_LINK} upgradeClickedEvent={this.props.upgradeClickedEvent} /> : ''}
                    <div>
                        <div className={`h-h2 ${hasError ? classes.errorText : ''}`}>
                            <span className="h-action-title">
                                <Typography variant="h4" color={theme.palette.gray.black} component="span">
                                    {data.primaryText}
                                </Typography>
                            </span>
                            {this.renderTag()}
                            {isExploringHigherPlan && <TimerIcon timerIconStyle={{marginLeft: theme.spacing()}}/> }
                            { upgradePlan && <SVGInline svg={UpgradeRocketIcon} width="21px" className={classes.upgradeIcon} /> }
                        </div>
                        <div className="h-s3 h-sm-create-instruction h-sub-title h-mt-6p h-mw-460p">
                            <Typography variant="body2" color={theme.palette.gray.gray3}>
                                {data.secondaryText}
                            </Typography>
                        </div>
                        {this.renderChildComponent()}
                        {lastUpdated?<div style={styles.lastChangedText}>
                          <Typography variant="caption">
                            {lastUpdated}
                          </Typography>
                        </div>:null}
                    </div>

                    { !hasError &&
                        <div className={`${classes.toggleContainer} h-toggle-container`}>
                        {children 
                        ?
                        <IconButton disableRipple sx={{'&:hover': {backgroundColor: "transparent"}}} onClick={upgradePlan ? undefined : this.toggleSubItem}>
                        <SVGInline width='24px' height='24px' svg={subItemActive ? SettingsActive: SettingsDeactive} className={` ${classes.setting_icon} h-mr-13p`} />
                        </IconButton>
                            : 
                        null}
                            
                        {showToggle && 
                            <HuiTooltip 
                                PopperProps={{ sx: sliderTooltipStyles }}
                                arrow 
                                placement='bottom-end'
                                title={this.showSliderTooltip(data)}
                            >
                                <Box>
                                    <InputSlider 
                                            id={id}
                                            sliderSwitched={handleToggle}
                                            value={this.state.state}
                                            disabled={upgradePlan || data.showTooltip}
                                            isHUI
                                            {...sliderProps}
                                    />
                                </Box>
                            </HuiTooltip>
                        }
                        </div>
                    }
                </div>

                 {this.renderChildren()}
                 {this.renderErrorAlert()}

                </React.Fragment>
            );
        } else 
            return <div className="h-h2">Unsupported `variant` field provided</div>;
    }
}


const styles = {
  toggleContainer: {
    display: "flex",
    alignItems: "center",
  },
  icon_btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  setting_icon: {
    marginRight: "25px",
    marginTop: "5px",
  },
  errorText: {
    color: "#E57373",
    fontWeight: "500",
  },
  lastChangedText: {
    fontFamily: "Open Sans",
    fontSize: "11px",
    lineHeight: "20px",
    letterSpacing: "0.23px",
    color: "#97A3B7",
  },
  upgradeIcon: {
    "& svg": {
      marginBottom: "-6px",
      marginLeft: "10px",
    },
  },
  tag: {
    background: 'linear-gradient(160deg, #FFE250 0%, #FFC350 100%)',
    borderRadius: '9px',
    color: theme.palette.gray.gray1,
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '12px',
    letterSpacing: '0.4px',
    padding: '2px 10px',
    marginLeft: '5px',
    cursor: 'pointer'
  },
  tagTooltip:{
    maxWidth: '390px',
    lineHeight: '18px',
  }
};


export const ListItem =  injectSheet(styles)(ListItemView);